import type { MouseEvent } from 'react'
import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

// Click bất cứ đâu trên ô <input type="date"> → mở native picker ngay.
// Mặc định browser chỉ mở khi click icon nhỏ bên phải; showPicker() chấp nhận
// được user-gesture nên gắn vào onClick là hợp lệ. Optional chaining để
// fallback an toàn cho browser cũ không hỗ trợ showPicker.
export function openNativeDatePicker(event: MouseEvent<HTMLInputElement>): void {
  event.currentTarget.showPicker?.()
}

export function formatVND(amount: number | null | undefined): string {
  if (amount == null) return '—'
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
    maximumFractionDigits: 0,
  }).format(amount)
}

// Múi giờ Việt Nam (UTC+7) — dữ liệu nhập theo giờ VN. Cột NGÀY dạng timestamptz
// (order_date/created_at/invoiced_at…) lưu UTC; filter theo NGÀY phải NEO biên ngày
// vào giờ VN, KHÔNG để Postgres/Supabase diễn giải chuỗi không-offset theo UTC — nếu
// không, bản ghi tạo lúc 0–7h sáng VN ở ngày biên bị lệch ±1 ngày. dayStartVn/dayEndVn
// trả chuỗi có '+07:00' để dùng với .gte/.lte trên cột timestamptz.
export const VN_TZ_OFFSET = '+07:00'

export function dayStartVn(date: string | null | undefined): string {
  return date ? `${date}T00:00:00${VN_TZ_OFFSET}` : ''
}

export function dayEndVn(date: string | null | undefined): string {
  return date ? `${date}T23:59:59.999${VN_TZ_OFFSET}` : ''
}

